import React from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  className?: string
  isDisabled?: boolean
}

export function CampaignWhiteButton({
  children,
  isDisabled = false,
  className = '',
  type = 'button',
  onClick,
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={onClick}
      className={`
        h-10 rounded-full flex-col justify-center items-center gap-2 inline-flex transition-all duration-300
        ${
          isDisabled
            ? 'bg-[#e3e3e4] text-[#98979a] cursor-not-allowed' // Gray for disabled
            : 'bg-transparent border border-black text-black hover:bg-black hover:text-white'
        }
        ${className}
      `}
      {...props}
      style={{
        boxShadow: isDisabled ? 'none' : '0 0 0 0 transparent', // Ensure no jumping
        transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
      }}
    >
      <div
        className={`
          self-stretch grow shrink basis-0 px-2 py-2.5 justify-center items-center gap-2 inline-flex
        `}
      >
        <div
          className={`
            text-center font-['Geist'] leading-tight tracking-tight font-medium text-2xl
          `}
        >
          {children}
        </div>
      </div>
    </button>
  )
}
